export enum CostPriceModel {
  MOVINGAVERAGE = '0',
  LASTRECEIPTPRICE = '1',
  TAHUAWAC = '2',
  AMRESTWAC = '3'
}

export const costPriceModelTranslationMap = {
  [CostPriceModel.MOVINGAVERAGE]: 'costPriceModels.movingAverage',
  [CostPriceModel.LASTRECEIPTPRICE]: 'costPriceModels.lastReceiptPrice',
  [CostPriceModel.TAHUAWAC]: 'costPriceModels.tahuaWeightedAverageCost',
  [CostPriceModel.AMRESTWAC]: 'costPriceModels.amrestWeightedAverageCost',
};